/**
 *
 * Asynchronously loads the component for TransportSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const TransportSetup = lazyLoad(
  () => import('./index'),
  module => module.TransportSetup,
);
